import BerthingPagination from './berthing-pagination.component'

export default BerthingPagination